import { render, staticRenderFns } from "./InfoProduct.vue?vue&type=template&id=72ee9e7c"
import script from "./InfoProduct.vue?vue&type=script&lang=js"
export * from "./InfoProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports